!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("prop-types"), require("react"), require("signature_pad"), require("trim-canvas")) : "function" == typeof define && define.amd ? define(["prop-types", "react", "signature_pad", "trim-canvas"], t) : "object" == typeof exports ? exports.SignatureCanvas = t(require("prop-types"), require("react"), require("signature_pad"), require("trim-canvas")) : e.SignatureCanvas = t(e["prop-types"], e.react, e.signature_pad, e["trim-canvas"]);
}(this, function (e, t, n, r) {
  return function (e) {
    function t(r) {
      if (n[r]) return n[r].exports;
      var a = n[r] = {
        exports: {},
        id: r,
        loaded: !1
      };
      return e[r].call(a.exports, a, a.exports, t), a.loaded = !0, a.exports;
    }
    var n = {};
    return t.m = e, t.c = n, t.p = "", t(0);
  }([function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function a(e, t) {
      var n = {};
      for (var r in e) t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
      return n;
    }
    function o(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }
    function u(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
      },
      c = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }
        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      }(),
      f = n(1),
      p = r(f),
      l = n(2),
      d = r(l),
      v = n(3),
      h = r(v),
      _ = n(4),
      g = r(_),
      m = function (e) {
        function t() {
          var e, n, r, u;
          o(this, t);
          for (var s = arguments.length, c = Array(s), f = 0; f < s; f++) c[f] = arguments[f];
          return n = r = i(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(c))), r._sigPad = null, r._excludeOurProps = function () {
            var e = r.props,
              t = (e.canvasProps, e.clearOnResize, a(e, ["canvasProps", "clearOnResize"]));
            return t;
          }, r.getCanvas = function () {
            return r._canvas;
          }, r.getTrimmedCanvas = function () {
            var e = document.createElement("canvas");
            return e.width = r._canvas.width, e.height = r._canvas.height, e.getContext("2d").drawImage(r._canvas, 0, 0), (0, g.default)(e);
          }, r.getSignaturePad = function () {
            return r._sigPad;
          }, r._checkClearOnResize = function () {
            r.props.clearOnResize && r._resizeCanvas();
          }, r._resizeCanvas = function () {
            var e = r.props.canvasProps || {},
              t = e.width,
              n = e.height;
            if (!t || !n) {
              var a = r._canvas,
                o = Math.max(window.devicePixelRatio || 1, 1);
              t || (a.width = a.offsetWidth * o), n || (a.height = a.offsetHeight * o), a.getContext("2d").scale(o, o), r.clear();
            }
          }, r.on = function () {
            return window.addEventListener("resize", r._checkClearOnResize), r._sigPad.on();
          }, r.off = function () {
            return window.removeEventListener("resize", r._checkClearOnResize), r._sigPad.off();
          }, r.clear = function () {
            return r._sigPad.clear();
          }, r.isEmpty = function () {
            return r._sigPad.isEmpty();
          }, r.fromDataURL = function (e, t) {
            return r._sigPad.fromDataURL(e, t);
          }, r.toDataURL = function (e, t) {
            return r._sigPad.toDataURL(e, t);
          }, r.fromData = function (e) {
            return r._sigPad.fromData(e);
          }, r.toData = function () {
            return r._sigPad.toData();
          }, u = n, i(r, u);
        }
        return u(t, e), c(t, [{
          key: "componentDidMount",
          value: function () {
            this._sigPad = new h.default(this._canvas, this._excludeOurProps()), this._resizeCanvas(), this.on();
          }
        }, {
          key: "componentWillUnmount",
          value: function () {
            this.off();
          }
        }, {
          key: "componentDidUpdate",
          value: function () {
            Object.assign(this._sigPad, this._excludeOurProps());
          }
        }, {
          key: "render",
          value: function () {
            var e = this,
              t = this.props.canvasProps;
            return d.default.createElement("canvas", s({
              ref: function (t) {
                e._canvas = t;
              }
            }, t));
          }
        }]), t;
      }(l.Component);
    m.propTypes = {
      velocityFilterWeight: p.default.number,
      minWidth: p.default.number,
      maxWidth: p.default.number,
      minDistance: p.default.number,
      dotSize: p.default.oneOfType([p.default.number, p.default.func]),
      penColor: p.default.string,
      throttle: p.default.number,
      onEnd: p.default.func,
      onBegin: p.default.func,
      canvasProps: p.default.object,
      clearOnResize: p.default.bool
    }, m.defaultProps = {
      clearOnResize: !0
    }, t.default = m;
  }, function (t, n) {
    t.exports = e;
  }, function (e, n) {
    e.exports = t;
  }, function (e, t) {
    e.exports = n;
  }, function (e, t) {
    e.exports = r;
  }]);
});